import E, { stdSerializers as a, symbols as v } from "pino";
import { z as m } from "zod";
const f = ["debug", "info", "warn", "error", "fatal", "audit"], T = m.enum(f), g = !process.env.NODE_ENV || process.env.NODE_ENV === "production", L = process.env.NEXT_PHASE === "phase-production-build", N = "process", u = () => globalThis[N], _ = () => `${u().cwd()}/node_modules/pino-opentelemetry-transport/lib/pino-opentelemetry-transport.js`, n = () => {
  let e = "info";
  g && (e = "warn"), L && (e = "error");
  const o = process.env.LOG_LEVEL, t = T.safeParse(o);
  return t.success && (e = t.data), e;
}, b = {
  level: n(),
  serializers: {
    err: a.err,
    req: a.req,
    res: a.res
  },
  customLevels: {
    debug: 20,
    info: 30,
    warn: 40,
    error: 50,
    fatal: 60,
    audit: 90
  },
  useOnlyCustomLevels: !0,
  timestamp: !0,
  name: "formbricks"
}, h = () => {
  const e = process.env.NEXT_RUNTIME === "edge", o = process.env.NEXT_RUNTIME === "nodejs" && process.env.OTEL_LOGS_ENABLED === "1" && !!process.env.OTEL_EXPORTER_OTLP_ENDPOINT, t = process.env.OTEL_SERVICE_NAME ?? "formbricks", d = process.env.npm_package_version ?? "0.0.0", p = () => ({
    target: _(),
    options: {
      loggerName: t,
      serviceVersion: d,
      resourceAttributes: {
        "service.name": t,
        "service.version": d,
        "deployment.environment": process.env.ENVIRONMENT ?? process.env.NODE_ENV ?? "development"
      }
    },
    level: n()
  }), i = {
    target: "pino-pretty",
    options: {
      colorize: !0,
      levelFirst: !0,
      translateTime: "SYS:standard",
      ignore: "pid,hostname,ip,requestId",
      customLevels: "trace:10,debug:20,info:30,warn:40,error:50,fatal:60,audit:90",
      useOnlyCustomProps: !0
    },
    level: n()
  };
  if (!g)
    return e ? void 0 : o ? { targets: [i, p()] } : { target: i.target, options: i.options };
  if (o)
    return { targets: [{
      target: "pino/file",
      options: { destination: 1 },
      // stdout
      level: n()
    }, p()] };
}, c = h(), O = c !== void 0 && "targets" in c, I = {
  ...b,
  transport: c,
  ...!O && {
    formatters: {
      level: (e) => ({ level: e })
    }
  }
}, r = E(I), S = (e) => {
  const o = e instanceof Error ? e.stack ?? e.message : String(e);
  u().stderr.write(`[logger] Pino transport error: ${o}
`);
}, R = (e) => {
  if (process.env.NEXT_RUNTIME !== "nodejs") return;
  e[v.streamSym]?.on?.("error", S);
};
R(r);
const P = {
  debug: r.debug.bind(r),
  info: r.info.bind(r),
  audit: r.audit.bind(r),
  warn: r.warn.bind(r),
  error: r.error.bind(r),
  fatal: r.fatal.bind(r)
}, w = {
  ...P,
  withContext: (e) => r.child(e),
  request: (e) => r.child({
    method: e.method,
    url: e.url
  })
}, l = w, s = (e, o) => {
  o && l.error(o, `Error during shutdown (${e})`), l.info({ event: e }, "Process is exiting"), r.flush();
}, y = () => {
  process.env.NEXT_RUNTIME === "nodejs" && (process.on("uncaughtException", (e) => {
    s("uncaughtException", e);
  }), process.on("unhandledRejection", (e) => {
    s("unhandledRejection", e);
  }), process.on("SIGTERM", () => {
    s("SIGTERM");
  }), process.on("SIGINT", () => {
    s("SIGINT");
  }));
};
if (process.env.NEXT_RUNTIME === "nodejs")
  try {
    y();
  } catch (e) {
    l.error(e, "Error attaching process event handlers");
  }
export {
  l as logger
};
